import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";


export class SequenceExpression extends RJExpressionNode
{
  _expressions:RJExpressionNode[];

  constructor( parser:RJParser, range:SourceRange = null )
  {
    super( parser, RJExpressionNodeType.SEQUENCE, range );
  }

  setExpressions( expressions:RJExpressionNode[] )
  {
    this._expressions = expressions;
    this._expressions.forEach( e => e._setParent( this ) );
  }

  cloneNode():SequenceExpression
  {
    let clone = new SequenceExpression( this.parser, this.sourceRange );
    let clonedExpressions:RJExpressionNode[] = [];
    this._expressions.forEach( e => clonedExpressions.push( e.cloneNode() ) );

    clone.setExpressions( clonedExpressions );
    return clone;
  }


  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    let sequenceExpressionElement  = new ElementType( "rj-sequence-expressions" ).create( this._expressions.map( e => e.createHTMLElement() ) );

    element.appendChild( sequenceExpressionElement );

    return element;
  }
}